import { backVersionDto, statusDto } from '@lib/models/status'
import { BackendService } from '../backend.service'
import { scopedLogger } from '@lib/utils/logUtils'
import { LogFunctions } from 'electron-log'

class StatusService extends BackendService {
  protected logger: LogFunctions

  constructor() {
    super('status')

    this.logger = scopedLogger('@services/backend/status')
  }

  async fetchStatus() {
    return await this.request(
      {
        method: 'GET',
        url: '/status'
      },
      statusDto,
      this.logger,
      { mustTrackCustomError: false }
    )
  }

  async fetchBackVersion() {
    return await this.request(
      {
        method: 'GET',
        url: '/status/version'
      },
      backVersionDto,
      this.logger
    )
  }
}

export const statusService = new StatusService()
